import { render, staticRenderFns } from "./PopupVideo.vue?vue&type=template&id=6606c849&"
import script from "./PopupVideo.vue?vue&type=script&lang=js&"
export * from "./PopupVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports